import { render, staticRenderFns } from "./OpenTodoView.vue?vue&type=template&id=9bc7f900&"
import script from "./OpenTodoView.vue?vue&type=script&lang=js&"
export * from "./OpenTodoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports